import { render } from "./TrendItem.vue?vue&type=template&id=2bc3a22c&scoped=true&ts=true"
import script from "./TrendItem.vue?vue&type=script&lang=ts"
export * from "./TrendItem.vue?vue&type=script&lang=ts"

import "./TrendItem.vue?vue&type=style&index=0&id=2bc3a22c&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc3a22c"]])

export default __exports__